import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { TabsContent } from '@/components/ui/tabs';
import { formatCurrency } from '@/lib/utils/formatters';
import { useContext } from 'react';
import { ApuracaoDetalhadaContext } from '@/contexts/ApuracaoDetalhadaContext';
import { AvisoDemonstracao } from '../aviso-demonstracao';

export function ApuracaoIcmsTab() {
  const ctx = useContext(ApuracaoDetalhadaContext);
  if (!ctx) {
    throw new Error('ApuracaoIcmsTab deve ser usado dentro de <ApuracaoDetalhadaProvider>');
  }

  return (
    <TabsContent value="apuracao-icms" className="space-y-6">
      <AvisoDemonstracao detalhe="Os valores desta aba são de exemplo, fixos na tela. Não são do contribuinte nem do período selecionado." />
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Entradas (Créditos) - ICMS</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>CFOP</TableHead>
                <TableHead>DESCRIÇÃO</TableHead>
                <TableHead className="text-right">VALOR OPERAÇÃO</TableHead>
                <TableHead className="text-right">BASE DE CÁLCULO</TableHead>
                <TableHead className="text-right">VALOR ICMS</TableHead>
                <TableHead className="text-right">BASE DE CÁLCULO ST</TableHead>
                <TableHead className="text-right">VALOR ICMS ST</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell className="font-medium">1101</TableCell>
                <TableCell>COMPRA PARA INDUSTRIALIZAÇÃO</TableCell>
                <TableCell className="text-right">{formatCurrency(84223395.51)}</TableCell>
                <TableCell className="text-right">{formatCurrency(85136785.69)}</TableCell>
                <TableCell className="text-right">{formatCurrency(85226855.08)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1102</TableCell>
                <TableCell>COMPRA PARA COMERCIALIZAÇÃO</TableCell>
                <TableCell className="text-right">{formatCurrency(85901662.1)}</TableCell>
                <TableCell className="text-right">{formatCurrency(85773676.06)}</TableCell>
                <TableCell className="text-right">{formatCurrency(85133240.43)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1151</TableCell>
                <TableCell>TRANSFERÊNCIA PARA INDUSTRIALIZAÇÃO</TableCell>
                <TableCell className="text-right">{formatCurrency(15513.12)}</TableCell>
                <TableCell className="text-right">{formatCurrency(15513.12)}</TableCell>
                <TableCell className="text-right">{formatCurrency(2792.36)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1152</TableCell>
                <TableCell>TRANSFERÊNCIA PARA COMERCIALIZAÇÃO</TableCell>
                <TableCell className="text-right">{formatCurrency(4068244.79)}</TableCell>
                <TableCell className="text-right">{formatCurrency(1965623.04)}</TableCell>
                <TableCell className="text-right">{formatCurrency(337937.93)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1202</TableCell>
                <TableCell>
                  DEVOLUÇÃO DE VENDA DE MERCADORIA ADQUIRIDA OU RECEBIDA DE TERCEIROS
                </TableCell>
                <TableCell className="text-right">{formatCurrency(26961.25)}</TableCell>
                <TableCell className="text-right">{formatCurrency(24177.9)}</TableCell>
                <TableCell className="text-right">{formatCurrency(3404.24)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1209</TableCell>
                <TableCell>
                  DEVOLUÇÃO DE MERCADORIA ADQUIRIDA OU RECEBIDA DE TERCEIROS, REMETIDA EM
                  TRANSFERÊNCIA
                </TableCell>
                <TableCell className="text-right">{formatCurrency(3288.03)}</TableCell>
                <TableCell className="text-right">{formatCurrency(1456.66)}</TableCell>
                <TableCell className="text-right">{formatCurrency(234.43)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1253</TableCell>
                <TableCell>COMPRA DE ENERGIA ELÉTRICA POR ESTABELECIMENTO COMERCIAL</TableCell>
                <TableCell className="text-right">{formatCurrency(157424.2)}</TableCell>
                <TableCell className="text-right">{formatCurrency(16337.56)}</TableCell>
                <TableCell className="text-right">{formatCurrency(2940.76)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1257</TableCell>
                <TableCell>
                  COMPRA DE ENERGIA ELÉTRICA PARA CONSUMO POR DEMANDA CONTRATADA
                </TableCell>
                <TableCell className="text-right">{formatCurrency(38101.64)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1303</TableCell>
                <TableCell>
                  AQUISIÇÃO DE SERVIÇO DE COMUNICAÇÃO POR ESTABELECIMENTO COMERCIAL
                </TableCell>
                <TableCell className="text-right">{formatCurrency(500.0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1353</TableCell>
                <TableCell>
                  AQUISIÇÃO DE SERVIÇO DE TRANSPORTE POR ESTABELECIMENTO COMERCIAL
                </TableCell>
                <TableCell className="text-right">{formatCurrency(5640.53)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1401</TableCell>
                <TableCell>
                  COMPRA PARA INDUSTRIALIZAÇÃO EM OPERAÇÃO COM MERCADORIA SUJEITA AO REGIME DE
                  SUBSTITUIÇÃO TRIBUTÁRIA
                </TableCell>
                <TableCell className="text-right">{formatCurrency(7391.03)}</TableCell>
                <TableCell className="text-right">{formatCurrency(4395.97)}</TableCell>
                <TableCell className="text-right">{formatCurrency(881.23)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1403</TableCell>
                <TableCell>
                  COMPRA PARA COMERCIALIZAÇÃO EM OPERAÇÃO COM MERCADORIA SUJEITA AO REGIME DE
                  SUBSTITUIÇÃO TRIBUTÁRIA
                </TableCell>
                <TableCell className="text-right">{formatCurrency(5231541.3)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">1406</TableCell>
                <TableCell>
                  COMPRA DE BEM PARA O ATIVO IMOBILIZADO CUJA MERCADORIA ESTÁ SUJEITA AO REGIME DE
                  SUBSTITUIÇÃO TRIBUTÁRIA
                </TableCell>
                <TableCell className="text-right">{formatCurrency(3785.04)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow className="bg-green-50 font-bold">
                <TableCell colSpan={2}>TOTAL GERAL:</TableCell>
                <TableCell className="text-right">{formatCurrency(15682448.54)}</TableCell>
                <TableCell className="text-right">{formatCurrency(2938465.91)}</TableCell>
                <TableCell className="text-right">{formatCurrency(504286.46)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Card className="border-red-200">
        <CardHeader className="bg-red-50/50">
          <CardTitle className="text-lg text-red-700 flex items-center gap-2">
            <Badge variant="outline" className="bg-red-100 text-red-700 border-red-300">
              SAÍDAS (DÉBITOS) - ICMS
            </Badge>
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>CFOP</TableHead>
                <TableHead>DESCRIÇÃO</TableHead>
                <TableHead className="text-right">VALOR OPERAÇÃO</TableHead>
                <TableHead className="text-right">BASE DE CÁLCULO</TableHead>
                <TableHead className="text-right">VALOR ICMS</TableHead>
                <TableHead className="text-right">BASE DE CÁLCULO ST</TableHead>
                <TableHead className="text-right">VALOR ICMS ST</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell className="font-medium">5101</TableCell>
                <TableCell>VENDA DE PRODUÇÃO DO ESTABELECIMENTO</TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(3245678.9)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(3245678.9)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(584222.2)}
                </TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">5102</TableCell>
                <TableCell>VENDA DE MERCADORIA ADQUIRIDA OU RECEBIDA DE TERCEIROS</TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(8932451.25)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(7845623.12)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(1412211.76)}
                </TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">5103</TableCell>
                <TableCell>
                  VENDA DE PRODUÇÃO DO ESTABELECIMENTO, EFETUADA FORA DO ESTABELECIMENTO
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(245789.45)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(245789.45)}
                </TableCell>
                <TableCell className="text-right text-red-700">{formatCurrency(44242.1)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">5405</TableCell>
                <TableCell>
                  VENDA DE MERCADORIA, ADQUIRIDA OU RECEBIDA DE TERCEIROS, SUJEITA AO REGIME DE
                  SUBSTITUIÇÃO TRIBUTÁRIA
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(1567234.67)}
                </TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(256789.12)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(46222.04)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">6101</TableCell>
                <TableCell>VENDA DE PRODUÇÃO DO ESTABELECIMENTO - INTERESTADUAL</TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(2134567.89)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(2134567.89)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(256146.15)}
                </TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-medium">6102</TableCell>
                <TableCell>
                  VENDA DE MERCADORIA ADQUIRIDA OU RECEBIDA DE TERCEIROS - INTERESTADUAL
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(4567890.23)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(4032456.78)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(482814.81)}
                </TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
                <TableCell className="text-right">{formatCurrency(0)}</TableCell>
              </TableRow>
              <TableRow className="bg-red-50 font-bold">
                <TableCell colSpan={2}>TOTAL GERAL:</TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(20693612.39)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(17495116.14)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(2779639.02)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(256789.12)}
                </TableCell>
                <TableCell className="text-right text-red-700">
                  {formatCurrency(46222.04)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Card className="bg-muted/30">
        <CardHeader>
          <CardTitle className="text-lg">Saldo ICMS a Pagar</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <Card className="border-red-200 bg-red-50/50">
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-muted-foreground">
                  Total Débitos (Saídas)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-2xl font-bold text-red-700">{formatCurrency(2779639.02)}</p>
              </CardContent>
            </Card>

            <Card className="border-green-200 bg-green-50/50">
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-muted-foreground">
                  Total Créditos (Entradas)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-2xl font-bold text-green-700">{formatCurrency(504286.46)}</p>
              </CardContent>
            </Card>

            <Card className="border-blue-200 bg-blue-50/50">
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-muted-foreground">
                  Saldo a Pagar
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-2xl font-bold text-blue-700">{formatCurrency(2275352.56)}</p>
              </CardContent>
            </Card>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Card className="border-orange-200 bg-orange-50/50">
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-muted-foreground">
                  ICMS ST a Pagar
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-2xl font-bold text-orange-700">{formatCurrency(46222.04)}</p>
              </CardContent>
            </Card>

            <Card className="border-purple-200 bg-purple-50/50">
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-muted-foreground">
                  Total ICMS + ST
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-2xl font-bold text-purple-700">{formatCurrency(2321574.6)}</p>
              </CardContent>
            </Card>
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  );
}
